{
  "Description": "GG",
  "RedundantCharacters": " -",
  "ValidationRegex": "^GY[0-9]{2,3}[A-Za-z]{2}$",
  "TestData": {
    "Valid": [
      "GY1 1AA",
      "GY111AA"
    ],
    "Invalid": [
      "CW3 9SS",
      "GG1 1AA",
      "SE5 0EG",
      "SE50EG",
      "WC2H 7LTa",
      "WC2H"
    ]
  }
}